<template>
    <div>
        <div v-if="!isItem && !disabled" class="choose-area-box" @click="showBgPopup()">
            <span>Chọn</span>
            <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
        </div>
        <div v-else class="choose-area-box">
            <span>Chọn</span>
            <span class="p-dropdown-trigger-icon pi pi-chevron-down"></span>
        </div>
        <div class="choose-area-dialog" v-if="showPopup">
            <div class="header-choose">
                <b>{{ title }}</b>
                <i class="pi pi-times" style="cursor: pointer;" @click="closeBgPopup()"/>
            </div>
            <div class="body-choose" v-if="data.length > 0">
                <div class="type">
                    <div class="choose-radio" v-if="type == 'radio'">
                        <div class="choose-radio-items" v-for="(item, index) in data" :key="`radio-${item.id}-${index}`" :id="`id-radio-${item.id}`" @click="openItem(item?.items ?? [], item.id)">
                            <RadioButton v-model="dataItem" :id="`radio-${item.id}-${index}`" :name="item.type" :value="item.id"/>
                            <label :for="`radio-${item.id}-${index}`" class="ml-2 d-flex justify-content-between w-100 align-items-center">
                                {{item.name}}
                                <div v-if="item?.items">
                                    <span> ({{ itemSelect[item.id] ? itemSelect[item.id].length : 0 }} / {{ item.items.length }}) </span>
                                    <i class="pi pi-cog"/>
                                </div>
                            </label> 
                        </div>
                    </div>
                    
                    <div class="choose-checkbox" v-else-if="type == 'checkbox'">
                        <div class="choose-radio-items" v-for="(item, index) in data" :key="`checkbox-${item.id}-${index}`">
                            <Checkbox v-model="totalItem[item.id]" :id="`checkbox-${item.id}-${index}`" name="item-data" :value="item.id" />
                            <label :for="`checkbox-${item.id}-${index}`" class="ml-2 d-flex justify-content-between w-100 align-items-center">
                                {{item.name}}
                                <div>
                                    <InputNumber style="width: 30px; height: 30px;" v-model="totalItem[item.id]" locale="de-DE" :minFractionDigits="0" :maxFractionDigits="0" :min="0" :max="totalMax" />
                                    <span>/ {{totalMax}}</span>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="d-flex align-items-center empty-items justify-content-center">
                <span>Không có dữ liệu</span>
            </div>
            <chooseAreaItem 
            v-if="items" :parentId="parent_id" :value="itemSelect[parent_id]" :parentValue="parentValue"
            :data="items" :title="checkItems.length > 0 ? 'Chọn khu vực - Hàng' : 'Chọn khu vực - Hộp'"
            @itemSelect="checkValue" :type="checkItems.length > 0 ? 'radio' : 'checkbox'" 
            :total="total" :totalMaxium="totalMax" :show="showItem" 
            :showBg="callBTL"
            @saveData="saveData"
            @backToList="backToList"
            @closeItem="closeItem()" :isItem="true" :key="keyChoose"/>
        </div>
    </div>
</template>

<script>
import chooseAreaItem from "@/components/chooseAreaItem";
export default {
  name: 'chooseArea',
  components: {
    chooseAreaItem
  },
  props: {
    title: String,
    total: Number,
    data: Array,
    showBg: Boolean,
    show: {
        type: Boolean,
        default: false
    },
    type: {
        type: String,
        default: "radio"
    },
    value: Array,
    isItem: Boolean,
    disabled: Boolean,
    showPopupChoose: Boolean,
    editPopup: String
  },
  watch: {
    "$props.showPopupChoose"() {
        this.showPopup = this.showPopupChoose;
    },
    "$props.showBg"() {
        // this.showPopup = this.showBg;
        if (!this.showBg) {
            this.callBTL = false;
        }
    },
    "$props.value"() {
        this.$set(this, "originData", this.value);
    },
    "$props.editPopup"() {
        // console.log("this.editPopupthis.editPopup", this.editPopup);    
        if (this.editPopup) {
            this.showBgPopup();
            setTimeout(() => {
                var ele = document.getElementById(`id-radio-${this.editPopup}`);
                if (ele) {
                    ele.dispatchEvent(new Event("click"));
                }
            }, 500);
        }
    }
  },
  data() {
    return {
        originData: [],
        callBTL: true,
        totalMax: 0,
        items: [],
        parent_id: null,
        checkItems: [],
        dataItem: null,
        itemSelect: [],
        parentValue: [],
        totalItem: {},
        checkItem: {},
        showItem: false,
        showPopup: false,
        keyChoose: 0
    }
  },
  mounted() {
    this.$set(this, "itemSelect", this.value);
    var dataTmp = Object.assign([], this.value);
    var key = Object.keys(dataTmp);
    key.map(m => {
        if (!this.originData[m]) {
            this.originData[m] = [];
        }
        this.originData[m].push(...dataTmp[m]);
    })
  },
  methods: {
    closeItem() {
        this.showItem = false;
        this.keyChoose++;
    },
    showBgPopup() {
        this.$set(this, "itemSelect", []);
        this.showPopup = true
        this.$emit('showBg');
        this.$set(this, "totalMax", this.total);
        this.$set(this, "itemSelect", this.value);
    },
    backToList() {
        this.closeBgPopup();
    },
    closeBgPopup() {
        this.showPopup = false;
        this.$emit('closeBg');
        for (const property in this.originData) {
            if (this.originData[property].length <= 0) {
                delete this.originData[property];
            }
        }
        this.$emit("input", this.originData);
        this.keyChoose++;
    },
    async openItem(items, id) {
        this.items = items;
        this.parent_id = id;
        this.itemSelect[id] = this.itemSelect[id] ?? [];
        this.checkItems = items.filter(f => f.items);
        this.showItem = true;
    },
    checkValue({parent_id, data}) {
        var value = [];
        var ids = [];
        if (data.length > 0) {
            data.map(m => {
                if (!ids.includes(m.id)) {
                    if (m.value.length > 0) {
                        value.push(m);
                        ids.push(m.id);
                    }
                }
            })
        }
        this.itemSelect[parent_id] = value;
        this.$set(this, "parentValue", [...this.itemSelect]);
        this.$set(this, "itemSelect", this.itemSelect);
    },
    saveData(){
        this.closeBgPopup();
        this.keyChoose++;
        this.$set(this, "originData", this.itemSelect);
        this.$emit("input", this.itemSelect);
    }
  }
}
</script>

<style lang="scss">
.choose-area-box {
    height: 42px;
    border: 1px solid #a6a6a6;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    color: #848484;
    cursor: pointer;
}


.choose-area-dialog {
    position: fixed;
    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 5px;
    width: 600px;
    min-height: 150px;
    height: fit-content;
    max-height: 600px;
    z-index: 999;
    box-shadow: 0 0 5px 5px #eee;
    padding: 10px 20px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    .choose-area-dialog {
        // min-height: 100%;
        height: 600px;
        top: 0;
        scale: 1.01;
    }
    .header-choose {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        border-bottom: 1px solid #eee;
    }

    .body-choose {
        max-height: 450px;
        overflow-y: auto;
        padding: 20px 0;
        .choose-radio-items {
            display: flex;
            align-items: center;
            cursor: pointer;
            padding: 10px;
            &:has(.p-radiobutton-checked), &:has(.p-checkbox-checked) {
                border-radius: 3px;
                border: 3px solid #A1000F;
                background-color: #F7F2F4;
                label {
                    color: #A1000F;
                }
            }
            label.ml-2 {
                padding: 0;
                margin: 0;
                cursor: pointer;
            }
        }
        .p-radiobutton-icon {
            width: 10px !important;
            height: 10px !important;
        }
        &::-webkit-scrollbar {
            width: 1px;
        }
    }
    .empty-items {
        height: 100px;
    }
    .footer-choose {
        display: flex;
        justify-content: flex-end;
        border-top: 1px solid #eee;
        padding: 10px 0;
        button {
            flex-basis: 20%;
            margin-right: 5px;
        }
    }
}

.choose-area-background {
    background-color: rgba(0, 0, 0, 0.7019607843);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 998;
}
</style>